import { useEffect, useState } from "react"

import { Card, Flex, Layout, Spin, Statistic } from "antd"
import { useTranslation } from "react-i18next"
import { connect } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"

import ButtonComponent from "../Components/Button"
import LoginHeader from "../Components/LoginHeader"
import LogOutText from "../Components/LogOutText"
//import ReactCodeInput from 'react-verification-code-input'

import PrivacyPolicy from "../Components/PrivacyPolicy"
import Images from "../Images"
import utils from "../Utils/utils"
//import cls from 'classname'

import { authErrorReset } from "./LoginPage/redux/auth.actions"
import { checkPassword, confirmPassword } from "./LoginPage/redux/auth.thunks"

const { Countdown } = Statistic

function VerifyCodePage({
  isMobile,
  error,
  fetching,
  resetError,
  userInfo,
  isConfirmEmail,
  ...props
}) {
  const navigate = useNavigate()
  const location = useLocation()
  const { state } = location

  const { t } = useTranslation()

  //const [isComplete, setIsComplete] = useState(false)
  //const [code, setCode] = useState(null)
  //const [children, setChildren] = useState(null)

  const [resendFetching, setResendFetching] = useState(false)
  const [deadline, setDeadline] = useState(null)

  //const [errorText, setErrorText] = useState(null)

  const email = isConfirmEmail ? userInfo?.email : state

  let content = isConfirmEmail
    ? { title: "Confirm email", text: "A 6-digit code has been sent your email", btn: "Continue" }
    : {
        title: "Reset password",
        text: "If there is an account associated with this email address, you will shortly receive a link to reset your password.",
        addText:
          "No email yet? Wait a few minutes, check your spam/junk folder, and make sure you entered the right email address.",
        btn: "Confirm"
      }

  useEffect(() => {
    document.title = "Verify Email - Chargeback"
    //let data = document.getElementsByClassName('code-block')[0].firstElementChild.children
    //setChildren(data)
  }, [])

  /* useEffect(() => {
    if (children) {
      initCodeBlock(children)
    }
  }, [children])*/

  /* useEffect(() => {
    if (error) {
      if (error.message) {
        setErrorText(Object.values(error.message)[0])
      } else if (typeof error === 'string') {
        setErrorText(error)
      } else {
        for (let i in error) {
          message.error(`${i}: ${error[i]}`, 5)
        }
      }
      resetError()
    }
    /!*eslint-disable-next-line react-hooks/exhaustive-deps*!/
  }, [error])*/

  /*function onChange(value) {
    setErrorText(null)
    if (!isNaN(value) && value.length > 5) {
      setIsComplete(true)
      setCode(value)
    } else {
      setIsComplete(false)
      setCode(null)
    }
  }*/

  /*function initCodeBlock(collection) {
    Array.from(collection).forEach(el => {
      el.placeholder = '-'
    })
  }*/

  function handleResendEmail() {
    if (email) {
      setDeadline(Date.now() + 1000 * 60)
      setResendFetching(true)
      if (isConfirmEmail) {
        alert(`resend code ConfirmEmail ${email}`)
      } else {
        props.checkPassword(email)
      }
    } else {
      if (isConfirmEmail) {
        navigate("/login")
      } else {
        navigate("/restore-password")
      }
    }
  }

  function onFinish() {
    setResendFetching(false)
    setDeadline(null)
  }

  return (
    <Layout>
      <Spin size="large" spinning={fetching}>
        <div className="login-row">
          <LoginHeader />
          <div className="login-content">
            <div className="content-main sign-up">
              <Card className="login-card">
                <h2 className="card-title" style={{ marginBottom: 12 }}>
                  {t(content.title)}
                </h2>
                <h4 className="card-subtitle-signup" style={{ margin: 0 }}>
                  {t(content.text)}
                  {/* <br/><span className="mark-text">{email}</span> */}
                </h4>
                {/* <div className={cls('error-text', {'error-text_empty': !errorText})}>{t(errorText)}</div>
                <ReactCodeInput
                  className={`code-block${errorText ? ' error' : ''}`}
                  fieldWidth={40}
                  fieldHeight={40}
                  onChange={onChange}
                />*/}
                <div className="verify-btn-block">
                  {/*<ButtonComponent type="primary"
                                   htmlType="submit"
                                   size="large"
                                   className="btn-primary_animation small"
                                   disabled={!isComplete}
                                   onClick={() => props.confirmPassword(code)}
                                   block
                  >
                    {t(content.btn)}
                  </ButtonComponent>*/}

                  <ButtonComponent
                    size="large"
                    href={`https://mail.${utils.checkMailDomain(email).link}.com`}
                    target="_blank"
                    rel="noopener noreferrer"
                    block
                  >
                    <img
                      className="btn-icon icon-space"
                      src={Images[utils.checkMailDomain(email).type]}
                      alt=""
                    />
                    {t("Go To")} {utils.checkMailDomain(email).name}
                  </ButtonComponent>
                </div>

                <div className="sign-up-link check-mail" style={{ justifyContent: "center" }}>
                  {resendFetching ? (
                    <div className="resend-timer">
                      <Countdown
                        title=""
                        value={deadline}
                        onFinish={onFinish}
                        format="mm:ss"
                        prefix={<span>{t("You will able to resend code in")} </span>}
                      />
                      <Spin />
                    </div>
                  ) : (
                    <Flex vertical gap={8} align="center">
                      <span className="card-subtitle-signup add-text">{t(content?.addText)}</span>
                      <span className="card-subtitle-signup">
                        {`${t("Haven't received a reset link?")} `}
                        <span className="text-link" onClick={handleResendEmail}>
                          {t("Resend")}
                        </span>
                      </span>
                    </Flex>
                  )}
                </div>
              </Card>
              <PrivacyPolicy />
              <LogOutText />
            </div>
          </div>
        </div>
      </Spin>
    </Layout>
  )
}

const mapStateToProps = (state) => {
  return {
    isDesktop: state.nav.isDesktop,
    isMobile: state.nav.isMobile,
    error: state.auth.error,
    fetching: state.auth.fetching,
    userInfo: state.auth.userInfo
  }
}

const mapDispatchToProps = (dispatch) => ({
  confirmPassword: (code) => dispatch(confirmPassword(code)),
  checkPassword: (email) => dispatch(checkPassword(email)),
  resetError: () => dispatch(authErrorReset())
})

export default connect(mapStateToProps, mapDispatchToProps)(VerifyCodePage)
